const setNestedValue = (obj: Record<string, any>, path: string[], value: any) => {
  let current = obj

  for (let i = 0; i < path.length - 1; i++) {
    const key = path[i]
    const nextKey = path[i + 1]

    // Determine if next level should be an array or object
    const isArrayIndex = /^\d+$/.test(nextKey)

    if (!current[key]) {
      current[key] = isArrayIndex ? [] : {}
    }

    current = current[key]
  }

  const lastKey = path[path.length - 1]

  // Handle duplicate keys - convert to array
  if (current[lastKey] !== undefined) {
    if (Array.isArray(current[lastKey])) {
      current[lastKey].push(value)
    } else {
      current[lastKey] = [current[lastKey], value]
    }
  } else {
    current[lastKey] = value
  }
}

const parseBracketNotation = (key: string): string[] => {
  // Parse key[subkey][index] into ['key', 'subkey', 'index']
  const parts: string[] = []
  let current = ''

  for (let i = 0; i < key.length; i++) {
    const char = key[i]

    if (char === '[') {
      if (current) {
        parts.push(current)
        current = ''
      }
    } else if (char === ']') {
      if (current) {
        parts.push(current)
        current = ''
      }
    } else {
      current += char
    }
  }

  if (current) {
    parts.push(current)
  }

  return parts
}

export const parseQuery = (query: string): Record<string, any> => {
  const res: Record<string, any> = {}

  query = query.trim().replace(/^(\?|#|&)/, '')

  if (!query) {
    return res
  }

  const pairs = query.split('&')

  for (const pair of pairs) {
    const eqIndex = pair.indexOf('=')

    let key: string
    let value: string

    if (eqIndex === -1) {
      // Key without value: foo -> { foo: '' }
      key = decodeURIComponent(pair)
      value = ''
    } else {
      key = decodeURIComponent(pair.slice(0, eqIndex))
      value = decodeURIComponent(pair.slice(eqIndex + 1))
    }

    // Check if key has bracket notation
    if (key.includes('[')) {
      const path = parseBracketNotation(key)
      setNestedValue(res, path, value)
      continue
    }

    // Simple key-value or duplicate key
    if (res[key] !== undefined) {
      if (Array.isArray(res[key])) {
        res[key].push(value)
      } else {
        res[key] = [res[key], value]
      }
    } else {
      res[key] = value
    }
  }

  return res
}
